// import React from "react";
// import PlanFeature from "./PlanFeature";

// export default function PricingMain({
//   setToastList,
//   toastList,
//   planToShow,
//   changePlan,
//   planType,
//   planTypeShow,
//   chkLogin,
//   profiles,
//   isAnyPlanPending,
// }) {
//   return (
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//       <div className="text-center mb-8">
//         <h1 className="text-4xl font-bold text-gray-900 mb-4">
//           Flexible Plans, Smarter Influencer Marketing
//         </h1>
//         <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//           TAMA's AI-powered platform connects brands with the right influencers seamlessly and
//           efficiently.
//         </p>
//       </div>

//       <div className="flex justify-center mb-12">
//         <div className="inline-flex rounded-md shadow-sm" role="group">
//           <button
//             onClick={() => changePlan("monthly")}
//             className={`px-6 py-3 text-sm font-medium rounded-l-lg ${
//               planType === "monthly"
//                 ? "bg-blue-600 text-white"
//                 : "bg-white text-gray-700 hover:bg-gray-50"
//             }`}
//           >
//             Billed Monthly
//           </button>
//           <button
//             onClick={() => changePlan("yearly")}
//             className={`px-6 py-3 text-sm font-medium rounded-r-lg relative ${
//               planType === "yearly"
//                 ? "bg-blue-600 text-white"
//                 : "bg-white text-gray-700 hover:bg-gray-50"
//             }`}
//           >
//             Billed Yearly
//             <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs px-2 py-1 rounded-full">
//               Save 50%
//             </span>
//           </button>
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-8">
//         {planToShow.map((item, i) => (
//           <div
//             key={`${item.name}-${i}`}
//             className={`rounded-lg shadow-lg overflow-hidden ${
//               profiles !== undefined && item.user_flag != 0 ? "ring-2 ring-blue-500" : ""
//             }`}
//           >
//             <div className="p-8 text-center">
//               <h2 className="text-2xl font-bold text-gray-900 mb-2">{item.name}</h2>
//               <p className="text-gray-500 mb-4">Start at</p>
//               <p className="text-4xl font-bold text-gray-900 mb-4">
//                 ${item.price}
//                 <span className="text-lg text-gray-500">/{planTypeShow}</span>
//               </p>
//               <p className="text-gray-600 mb-6">{item.description}</p>
//             </div>

//             <div className="flex justify-center space-x-4 pb-6">
//               <img src="images/instagram.png" alt="instagram" className="h-8 w-8" />
//               <img src="images/tiktok.png" alt="tiktok" className="h-8 w-8" />
//               <img src="images/youtube.png" alt="Youtube" className="h-8 w-8" />
//             </div>

//             <div className="px-6 pb-8 text-center">
//               {profiles !== undefined ? (
//                 item.user_flag != 0 ? (
//                   <div>
//                     <button className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-4 rounded-lg">
//                       Active
//                     </button>
//                     <div className="text-sm text-gray-500 mt-2"></div>
//                   </div>
//                 ) : (
//                   <div>
//                     {item.planaction !== "Pending" ? (
//                       <>
//                         <button
//                           onClick={() => chkLogin(item, item.planaction)}
//                           className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg"
//                         >
//                           {item.planaction}
//                         </button>
//                         <div className="text-sm text-gray-500 mt-2">
//                           {item.startdate !== "" ? "(" + item.startdate + ")" : ""}
//                         </div>
//                       </>
//                     ) : (
//                       <>
//                         <button
//                           onClick={() => chkLogin(item, item.planaction)}
//                           className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-4 rounded-lg relative"
//                         >
//                           {item.planaction}
//                         </button>
//                         <div className="text-sm text-gray-500 mt-2">
//                           {item.startdate !== ""
//                             ? "(Plan will be active from " + item.startdate + ")"
//                             : ""}
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 )
//               ) : (
//                 <button
//                   onClick={() => chkLogin(item, "subscribe")}
//                   className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg"
//                 >
//                   Get Started
//                 </button>
//               )}
//             </div>

//             <PlanFeature planFeature={item.features} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import { storageHandler } from "../../Helpers/storage";
import PlanFeature from "./PlanFeature";

const Check = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

// const getHoverGradientClass = (index) => {
//   const hoverGradients = [
//     "group-hover:from-blue-600 group-hover:to-indigo-700",
//     "group-hover:from-purple-600 group-hover:to-violet-700",
//     "group-hover:from-pink-600 group-hover:to-rose-700",
//     "group-hover:from-teal-600 group-hover:to-emerald-700",
//   ];
//   return hoverGradients[index % hoverGradients.length];
// };

const getCardIcon = (index) => {
  const icons = [
    <svg
      key="0"
      className="w-7 h-7 text-green-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13 10V3L4 14h7v7l9-11h-7z"
      />
    </svg>,
    <svg
      key="1"
      className="w-7 h-7 text-green-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      />
    </svg>,
    <svg
      key="2"
      className="w-7 h-7 text-green-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      />
    </svg>,
    <svg
      key="3"
      className="w-7 h-7 text-green-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
      />
    </svg>,
  ];
  return icons[index % icons.length];
};

export default function PricingMain({
  setToastList,
  toastList,
  planToShow,
  changePlan,
  planType,
  planTypeShow,
  chkLogin,
  profiles,
  isAnyPlanPending,
  loadingPlanId = null,
}) {
  console.log("🚀 ~ PricingMain ~ planToShow:", planToShow);
  let UserData = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      UserData = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }

  const renderPricing = (item) => {
    const shouldShowFreeTrial =
      (item?.user_had_trial === 0 &&
        item?.is_trial === 1 &&
        UserData.isUserHasSubscription === 0) ||
      (!UserData && item?.is_trial === 1);

    return (
      <div className="mt-4">
        <span
          className={`${
            shouldShowFreeTrial
              ? "line-through text-gray-600 text-2xl"
              : "text-green-600 font-bold text-3xl"
          }`}
        >
          ${item.price}
        </span>
        {shouldShowFreeTrial && (
          <span className="text-3xl font-bold text-green-600"> $0</span>
        )}
        <span className="text-green-500/80 text-lg">/{planTypeShow}</span>
      </div>
    );
  };

  const renderRibbon = (item) => {
    if (item?.user_trial === 1) {
      return (
        <div className="absolute -top-3 -right-3 z-20">
          <div className="relative">
            <div className="bg-gradient-to-r from-emerald-500 to-green-600 px-6 py-2 shadow-xl transform rotate-12">
              <div className="absolute -left-1 top-0 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-emerald-700 border-t-4 border-t-emerald-700 border-b-4 border-b-emerald-700 transform -rotate-45"></div>
              <div className="absolute -right-1 top-0 w-0 h-0 border-l-4 border-l-green-700 border-r-4 border-r-transparent border-t-4 border-t-green-700 border-b-4 border-b-green-700 transform rotate-45"></div>
              <span className="relative text-white text-xs font-bold tracking-wide uppercase whitespace-nowrap">
                {item?.trial_days_left} Days Left
              </span>
            </div>
          </div>
        </div>
      );
    } else if (
      item?.user_had_trial === 0 &&
      item?.is_trial === 1 &&
      UserData.isUserHasSubscription === 0
    ) {
      return (
        <div className="absolute -top-3 -right-3 z-20">
          <div className="relative">
            <div className="bg-gradient-to-r from-emerald-500 to-green-600 px-6 py-2 shadow-xl transform rotate-12">
              <div className="absolute -left-1 top-0 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-emerald-700 border-t-4 border-t-emerald-700 border-b-4 border-b-emerald-700 transform -rotate-45"></div>
              <div className="absolute -right-1 top-0 w-0 h-0 border-l-4 border-l-green-700 border-r-4 border-r-transparent border-t-4 border-t-green-700 border-b-4 border-b-green-700 transform rotate-45"></div>
              <span className="relative text-white text-xs font-bold tracking-wide uppercase whitespace-nowrap">
                {item?.trial_days} Days FREE TRIAL
              </span>
            </div>
          </div>
        </div>
      );
    } else if (!UserData && item?.is_trial === 1) {
      return (
        <div className="absolute -top-3 -right-3 z-20">
          <div className="relative">
            <div className="bg-gradient-to-r from-emerald-500 to-green-600 px-6 py-2 shadow-xl transform rotate-12">
              <div className="absolute -left-1 top-0 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-emerald-700 border-t-4 border-t-emerald-700 border-b-4 border-b-emerald-700 transform -rotate-45"></div>
              <div className="absolute -right-1 top-0 w-0 h-0 border-l-4 border-l-green-700 border-r-4 border-r-transparent border-t-4 border-t-green-700 border-b-4 border-b-green-700 transform rotate-45"></div>
              <span className="relative text-white text-xs font-bold tracking-wide uppercase whitespace-nowrap">
                {item?.trial_days} Days FREE TRIAL
              </span>
            </div>
          </div>
        </div>
      );
    }
    // if (item?.is_trial === 1) {
    //   return (
    //     <div className="absolute -top-3 -right-3 z-20">
    //       <div className="relative">
    //         <div className="bg-gradient-to-r from-emerald-500 to-green-600 px-6 py-2 shadow-xl transform rotate-12">
    //           <div className="absolute -left-1 top-0 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-emerald-700 border-t-4 border-t-emerald-700 border-b-4 border-b-emerald-700 transform -rotate-45"></div>
    //           <div className="absolute -right-1 top-0 w-0 h-0 border-l-4 border-l-green-700 border-r-4 border-r-transparent border-t-4 border-t-green-700 border-b-4 border-b-green-700 transform rotate-45"></div>
    //           <span className="relative text-white text-xs font-bold tracking-wide uppercase whitespace-nowrap">
    //             {item?.trial_days} Days FREE TRIAL
    //           </span>
    //         </div>
    //       </div>
    //     </div>
    //   );
    // }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-green-0 to-green-50 py-4 px-2">
      <div className="max-w-full mx-auto">
        <div className="text-center mb-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600">
              Flexible Plans,
            </span>
            Smarter Influencer Marketing
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            TAMA's AI-powered platform connects brands with the right
            influencers seamlessly and efficiently.
          </p>
        </div>

        <div className="flex justify-center mb-6">
          <div className="inline-flex rounded-md shadow-sm" role="group">
            <button
              onClick={() => changePlan("monthly")}
              className={`px-6 py-3 text-sm font-medium rounded-l-lg ${
                planType === "monthly"
                  ? "bg-green-600 text-gray-800"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              Billed Monthly
            </button>
            <button
              onClick={() => changePlan("yearly")}
              className={`px-6 py-3 text-sm font-medium rounded-r-lg relative ${
                planType === "yearly"
                  ? "bg-green-600 text-gray-800"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              Billed Yearly
              <span className="absolute -top-2 -right-2 bg-orange-500 text-gray-600 text-xs px-2 py-1 rounded-full">
                Save 50%
              </span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 2xl:grid-cols-4 gap-3 items-stretch">
          {planToShow?.map((item, i) => (
            <div
              key={`${item.name}-${i}`}
              className={`rounded-3xl group relative 
                ${
                  profiles !== undefined && item.user_flag !== 0
                    ? "border-2 border-green-600"
                    : "border-2 border-transparent"
                }`}
            >
              {/* {item?.is_trial === 1 && item?.user_trial === 1 ? (
                <div className="absolute -top-3 -right-3 z-20">
                  <div className="relative">
                    <div className="bg-gradient-to-r from-emerald-500 to-green-600 px-6 py-2 shadow-xl transform rotate-12">
                      <div className="absolute -left-1 top-0 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-emerald-700 border-t-4 border-t-emerald-700 border-b-4 border-b-emerald-700 transform -rotate-45"></div>
                      <div className="absolute -right-1 top-0 w-0 h-0 border-l-4 border-l-green-700 border-r-4 border-r-transparent border-t-4 border-t-green-700 border-b-4 border-b-green-700 transform rotate-45"></div>
                      <span className="relative text-white text-xs font-bold tracking-wide uppercase whitespace-nowrap">
                        {item?.user_trial
                          ? `${item?.trial_days_left} Days Left`
                          : item?.trial_days
                          ? `${item?.trial_days} Days FREE TRIAL`
                          : null}
                      </span>
                    </div>
                  </div>
                </div>
              ) : null} */}
              {renderRibbon(item)}
              <div className="relative h-full rounded-3xl bg-white shadow-xl group-hover:shadow-lg transition-all duration-300 overflow-hidden flex flex-col">
                <div
                  className={`bg-gradient-to-r p-4 text-center relative overflow-hidden transition-all duration-300`}
                >
                  <div className="absolute inset-0 opacity-20">
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                  </div>
                  <div className="relative z-10">
                    <div className="flex justify-center">
                      <div className="p-3 bg-white/20 rounded-full backdrop-blur-sm">
                        {getCardIcon(i)}
                      </div>
                    </div>
                    <h2 className="text-2xl font-bold text-green-800">
                      {item.name}
                    </h2>
                    {/* <p className="text-green-500/80 text-sm">Start at</p> */}
                    {renderPricing(item)}
                  </div>
                </div>

                <div className="p-6 flex flex-col" style={{ height: "280px" }}>
                  {/* Description - Fixed height container */}
                  <div className="h-16 flex items-center justify-center mb-4">
                    <p className="text-gray-600 text-center leading-relaxed text-sm line-clamp-3">
                      {item.description}
                    </p>
                  </div>

                  {/* Social Icons */}
                  <div className="flex justify-center space-x-6 mb-6">
                    <div className="group/icon p-3 bg-gradient-to-r from-pink-100 to-rose-100 rounded-full transition-all duration-300">
                      <img
                        src="images/instagram.png"
                        alt="instagram"
                        className="h-5 w-5"
                      />
                    </div>
                    <div className="group/icon p-3 bg-gradient-to-r from-gray-100 to-slate-100 rounded-full transition-all duration-300">
                      <img
                        src="images/tiktok.png"
                        alt="tiktok"
                        className="h-5 w-5"
                      />
                    </div>
                    <div className="group/icon p-3 bg-gradient-to-r from-red-100 to-rose-100 rounded-full transition-all duration-300">
                      <img
                        src="images/youtube.png"
                        alt="Youtube"
                        className="h-5 w-5"
                      />
                    </div>
                  </div>

                  {/* Button - This will be pushed to bottom */}
                  <div className="mt-auto">
                    {profiles !== undefined ? (
                      item.user_flag !== 0 ? (
                        <div>
                          <button
                            className="w-full text-white font-bold py-3 px-4 rounded-2xl transform transition-all duration-300 hover:scale-[1.02] shadow-lg hover:shadow-md"
                            style={{
                              backgroundColor: "oklch(62.7% 0.194 149.214)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "oklch(45.9% 0.187 3.815)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "oklch(62.7% 0.194 149.214)";
                            }}
                          >
                            <span className="flex items-center justify-center">
                              <Check className="w-5 h-5 mr-2" />
                              Active
                            </span>
                          </button>
                        </div>
                      ) : (
                        <div>
                          {item.planaction !== "Pending" ? (
                            <>
                              <button
                                onClick={() => chkLogin(item, item.planaction)}
                                disabled={loadingPlanId === item.id}
                                className={`w-full text-white font-bold py-3 px-4 rounded-2xl transform transition-all duration-300 hover:scale-[1.02] shadow-lg hover:shadow-md ${
                                  loadingPlanId === item.id
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                                style={{ backgroundColor: item.planaction === "Canceled" ? "oklch(62.7% 0.194 29)" : "oklch(26.9% 0 0)" }}
                                onMouseEnter={(e) => {
                                  if (loadingPlanId !== item.id) {
                                    e.currentTarget.style.backgroundColor =
                                      "oklch(62.7% 0.194 149.214)";

                                    // Handle hover text change for Canceled status
                                    if (item.planaction === "Canceled") {
                                      const span =
                                        e.currentTarget.querySelector(
                                          ".action-btn-label"
                                        );
                                      if (span) span.textContent = "Reactive";
                                    }
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (loadingPlanId !== item.id) {
                                    e.currentTarget.style.backgroundColor =
                                      item.planaction === "Canceled" ? "oklch(62.7% 0.194 29)" : "oklch(26.9% 0 0)";

                                    // Reset hover text change for Canceled status
                                    if (item.planaction === "Canceled") {
                                      const span =
                                        e.currentTarget.querySelector(
                                          ".action-btn-label"
                                        );
                                      if (span)
                                        span.textContent = item.planaction;
                                    }
                                  }
                                }}
                              >
                                {loadingPlanId === item.id ? (
                                  <span className="flex items-center justify-center">
                                    <svg
                                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                      ></circle>
                                      <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      ></path>
                                    </svg>
                                    Processing...
                                  </span>
                                ) : (
                                  <span className="action-btn-label">
                                    {item.planaction}
                                  </span>
                                )}
                              </button>
                              {item.startdate !== "" && (
                                <div className="text-sm text-gray-500 mt-3 text-center">
                                  ({item.startdate})
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              {item.startdate !== "" && (
                                <div className="text-sm text-gray-500 mb-3 text-center">
                                  (Plan will be active from {item.startdate})
                                </div>
                              )}
                              <button
                                onClick={() => chkLogin(item, item.planaction)}
                                disabled={loadingPlanId === item.id}
                                className={`w-full bg-yellow-400 text-white font-bold py-3 px-4 rounded-2xl transform transition-all duration-300 hover:scale-[1.02] shadow-lg hover:shadow-md relative overflow-hidden ${
                                  loadingPlanId === item.id
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                                onMouseEnter={(e) => {
                                  if (loadingPlanId !== item.id) {
                                    const span =
                                      e.currentTarget.querySelector(
                                        ".pending-btn-label"
                                      );
                                    if (span) span.textContent = "Cancel";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (loadingPlanId !== item.id) {
                                    const span =
                                      e.currentTarget.querySelector(
                                        ".pending-btn-label"
                                      );
                                    if (span)
                                      span.textContent = item.planaction;
                                  }
                                }}
                              >
                                <span className="relative z-10 pending-btn-label">
                                  {loadingPlanId === item.id
                                    ? "Processing..."
                                    : item.planaction}
                                </span>
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                              </button>
                            </>
                          )}
                        </div>
                      )
                    ) : (
                      <button
                        onClick={() => chkLogin(item, "subscribe")}
                        disabled={loadingPlanId === item.id}
                        className={`w-full text-white font-bold py-3 px-4 rounded-2xl transform transition-all duration-300 hover:scale-[1.02] shadow-lg hover:shadow-md ${
                          loadingPlanId === item.id
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        style={{ backgroundColor: "oklch(26.9% 0 0)" }}
                        onMouseEnter={(e) => {
                          if (loadingPlanId !== item.id) {
                            e.currentTarget.style.backgroundColor =
                              "oklch(62.7% 0.194 149.214)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (loadingPlanId !== item.id) {
                            e.currentTarget.style.backgroundColor =
                              "oklch(26.9% 0 0)";
                          }
                        }}
                      >
                        {loadingPlanId === item.id ? (
                          <span className="flex items-center justify-center">
                            <svg
                              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Processing...
                          </span>
                        ) : (
                          "Get Started"
                        )}
                      </button>
                    )}
                  </div>
                </div>

                {/* Features - Fixed at bottom */}
                <div className="mt-auto">
                  <PlanFeature planFeature={item.features} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
